"use strict";
/*
 * -------------------------------------------------------
 * THIS FILE WAS AUTOMATICALLY GENERATED (DO NOT MODIFY)
 * -------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultSectionItemType = exports.HeaderConsumer = exports.HeaderLocale = exports.HeaderStore = void 0;
/* tslint:disable */
/* eslint-disable */
var HeaderStore;
(function (HeaderStore) {
    HeaderStore["de"] = "de";
    HeaderStore["nl"] = "nl";
    HeaderStore["es"] = "es";
    HeaderStore["at"] = "at";
    HeaderStore["us"] = "us";
    HeaderStore["business"] = "business";
    HeaderStore["business_nl"] = "business_nl";
    HeaderStore["business_es"] = "business_es";
    HeaderStore["business_at"] = "business_at";
    HeaderStore["business_us"] = "business_us";
})(HeaderStore || (exports.HeaderStore = HeaderStore = {}));
var HeaderLocale;
(function (HeaderLocale) {
    HeaderLocale["en"] = "en";
    HeaderLocale["de"] = "de";
    HeaderLocale["nl"] = "nl";
    HeaderLocale["es"] = "es";
})(HeaderLocale || (exports.HeaderLocale = HeaderLocale = {}));
var HeaderConsumer;
(function (HeaderConsumer) {
    HeaderConsumer["catalog"] = "catalog";
    HeaderConsumer["payments"] = "payments";
    HeaderConsumer["dashboard"] = "dashboard";
})(HeaderConsumer || (exports.HeaderConsumer = HeaderConsumer = {}));
var SearchResultSectionItemType;
(function (SearchResultSectionItemType) {
    SearchResultSectionItemType["product"] = "product";
    SearchResultSectionItemType["category"] = "category";
    SearchResultSectionItemType["popularSearch"] = "popularSearch";
    SearchResultSectionItemType["popularCategory"] = "popularCategory";
})(SearchResultSectionItemType || (exports.SearchResultSectionItemType = SearchResultSectionItemType = {}));
//# sourceMappingURL=schema.graphql.js.map